import React from 'react';
import { formatToRub } from 'utils';
import { PriceMediaCardContent } from '../../../price-media-card';
import { Typography } from '../../../typography';
import {
  oldCartContentPrice,
  oldCartContentPriceWrapper,
  oldCartContentTitle,
  oldCartContentValue,
  oldCartContentWrapper,
 } from './old-card-content-styles';

type OldCardContentProps = {
  displayedName: string;
  price: number;
}

export const OldCardContent: React.FC<OldCardContentProps> = ({ displayedName, price }) => (
  <PriceMediaCardContent >
    <>
      <div className={oldCartContentWrapper}>
        <Typography className={oldCartContentTitle} variant="l" size="subtitle">
          {displayedName}
        </Typography>
      </div>
      <div className={oldCartContentPriceWrapper}>
        <Typography className={oldCartContentPrice} variant="h3">
          от
          <span className={oldCartContentValue}>
            {' '}
            {formatToRub(price)}{' '}
          </span>
          ₽
        </Typography>
      </div>
    </>
  </PriceMediaCardContent>
);
